export const OUTLOOK_SYNC_FREQUENCY = {
  emails: {
    intervalMinutes: 10,
  },
  contacts: {
    intervalMinutes: 10,
  },
  calendar: {
    intervalMinutes: 10,
    daysBack: 15,
    defaultDaysAfter: 30,
  },
  tasks: {
    intervalMinutes: 10,
    daysBack: 365,
    daysAfter: 30,
  },
} as const;

export const OUTLOOK_SYNC_CALENDAR_ROLLING_WINDOW_FEATURE_FLAG =
  'microsoft-outlook-sync-calendars-rollingwindow-shown';
